module.exports = __webpack_public_path__ + "img/q5.cc7eaa9d.jpg";